var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X",
    clipPath: "url(#clip0_845_1722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72563 0H25.2744C29.265 0 32.5 3.23502 32.5 7.22563V24.6269C32.5 28.6175 29.265 31.8525 25.2744 31.8525H7.72563C3.73502 31.8525 0.5 28.6175 0.5 24.6269V7.22563C0.5 3.23502 3.73502 0 7.72563 0ZM22.9912 9.27187H20.7337L17.0131 13.5244L13.7969 9.27187H9.13875L14.7044 16.5506L9.42937 22.58H11.6881L15.76 17.9281L19.3181 22.58H23.8612L18.0594 14.9094L22.9912 9.27187ZM21.1925 21.2287H19.9412L11.775 10.5525H13.1175L21.1925 21.2287Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_1722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.8525,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.e3a46aeb4e6536f27f13ef1f18969826.svg";
export { ForwardRef as ReactComponent };